// extracted by mini-css-extract-plugin
export var chatHtmlText = "_u6-2";
export var chatLink = "_u6-0";
export var chatText = "_u6-1";